// import coolRadio from "./CoolRadio.vue"
// import coolCheckbox from "./CoolCheckbox.vue"
// import coolButton from "./CoolButton.vue"
// import fadeAndSlide from "./FadeAndSlide.vue"
// import select2 from "./Select2.vue"
// import modalDialog from "./ModalDialog.vue"
//import labels from "./labels.ts";
// import utils from "./utils.js";
import {
    /*validate,*/ reportValidity,
    getLegacyFormSubmitValidation,
    getInvalidItems,
    getAllVueElements,
} from "./legacyFormSubmit";

export default {
    //coolRadio: coolRadio,
    //coolCheckbox: coolCheckbox,
    //coolButton: coolButton,
    //modalDialog: modalDialog,
    //labels: labels,
    //fadeAndSlide: fadeAndSlide,
    //select2: select2,
    //utils: utils,
    legacyFormSubmit: {
        //validate,
        reportValidity,
        getLegacyFormSubmitValidation,
        getInvalidItems,
        getAllVueElements,
    },
};
